/**
 * Spec 297 T032 — the one "retired" line a detail surface shows for a row the lists no longer carry.
 *
 * Any retire signal retires (clarification 1): the flag off, or the stamp set. A stamped row says when, in Eastern
 * (the project's display zone); a flag-only retirement (a state-based table, where the merge sets no stamp) says only
 * that it is retired. A live row has no line.
 */
import { formatEasternDate } from './dateFormatter';

export interface RetireSignals {
  is_active?: boolean | null;
  deactivated_at?: string | null;
}

export function retiredLabel(row: RetireSignals): string | null {
  if (row.deactivated_at) return `Retired on ${formatEasternDate(row.deactivated_at)}`;
  if (row.is_active === false) return 'Retired';
  return null;
}
